import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function OrgGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (!user?.orgId) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
